const ACTIONS = {
  TOPICS: "topics",
  PROVIDERS: "providers",
};

export default ACTIONS;
